// components/BlogPage.jsx
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import helpers from "../../../lib/crypto";
import { useFunctionContext } from "../../context/FunctionalContext";

// const API_URL = import.meta.env.VITE_API_URL;

export default function BlogView() {
  const [showContent, setShowContent] = useState(false);
  const { id } = useParams();
  const { posts } = useFunctionContext();

  const post = posts.find((p) => p.posting_id === id);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowContent(true);
    }, 1000);

    return () => clearTimeout(timer);
  });

  // const [post, setPost] = useState(null);
  // const [loading, setLoading] = useState(false);

  // useEffect(() => {
  //   // setLoading(true);
  //   const fetchSinglePost = async () => {
  //     try {
  //       const payload = {
  //         skip: 0,
  //         limit: 0,
  //         posting_id: id,
  //         key: "crm",
  //         organisation_id: "OB0788A47F46044",
  //       };
  //       const encrypted = helpers.encryptobj(payload);

  //       const res = await axios.post(`${API_URL}/admin_get/postings`, {
  //         enc: encrypted,
  //       });

  //       setPost(res.data?.posting);
  //     } catch (err) {
  //       console.error("Error fetching post:", err);
  //     }
  //   };

  //   fetchSinglePost();
  // }, [id]);

  if (!post || !showContent)
    return (
      <div className="max-w-6xl mx-auto py-6 md:py-16 my-24 px-6">
        <div className="animate-pulse max-w-6xl mx-auto px-4 py-6">
          <div className="h-6 bg-gray-700 rounded w-3/4 mb-4"></div>
          <div className="h-4 bg-gray-700 rounded w-2/3 mb-4"></div>

          <div className="relative w-full h-[300px] bg-gray-800 rounded-lg mb-8"></div>

          <div className="space-y-3 mb-10">
            <div className="h-4 bg-gray-700 rounded w-full"></div>
            <div className="h-4 bg-gray-700 rounded w-5/6"></div>
            <div className="h-4 bg-gray-700 rounded w-2/3"></div>
          </div>

          <div className="relative w-full h-[200px] bg-gray-800 rounded-lg mb-8"></div>

          {[1, 2, 3, 4, 5, 6].map((_, idx) => (
            <div key={idx} className="mb-10">
              {/* Section Title */}
              <div className="h-5 bg-gray-600 rounded w-2/3 mb-4"></div>

              <div className="space-y-3">
                {[1, 2, 3, 4].map((_, bIdx) => (
                  <div key={bIdx} className="flex items-start space-x-2">
                    <div className="w-2 h-2 mt-2 rounded-full bg-gray-500"></div>
                    <div className="h-4 bg-gray-700 rounded w-full"></div>
                  </div>
                ))}
              </div>
            </div>
          ))}

          {/* Final Tip Block */}
          <div className="h-5 bg-gray-600 rounded w-1/2 mb-4"></div>
          <div className="space-y-2">
            <div className="h-4 bg-gray-700 rounded w-5/6"></div>
            <div className="h-4 bg-gray-700 rounded w-2/3"></div>
            <div className="h-4 bg-gray-700 rounded w-4/5"></div>
            <div className="h-4 bg-gray-700 rounded w-3/4"></div>
          </div>
        </div>
      </div>
    );

  return (
    <div className="w-full lg:max-w-7xl mx-auto py-6 md:py-16 my-24 px-6">
      {/* <h1 className="text-4xl font-bold mb-6 text-center">{post.title}</h1> */}
      <div
        className="prose prose-sm lg:prose-lg prose-invert max-w-none text-left lg-4 lg:pt-10"
        dangerouslySetInnerHTML={{ __html: post.description }}
      />
    </div>
  );
}
